import React from 'react';
import PropTypes from 'prop-types';
import { IconButton, PhoneIcon } from '@paypalcorp/pp-react';
import { StyleSheet, css } from '../../utility/paypalAphrodite';

const styles = StyleSheet.create({
  iconLink: {
    marginRight: '0.375rem',
  },
});

function SocialShareMobile({ handleMobileClick, linkTitle }) {
  return (
    <IconButton
      onClick={handleMobileClick}
      className={`${css(styles.iconLink)}`}
      data-testid="social-share-mobile"
      size="sm"
      buttonType="secondary"
      svgIconComponent={PhoneIcon}
    >
      {linkTitle}
    </IconButton>
  );
}

SocialShareMobile.propTypes = {
  handleMobileClick: PropTypes.func,
  linkTitle: PropTypes.string,
  color: PropTypes.color,
};

export default SocialShareMobile;
